<button class="addButton"
        [class._disabled]="disabled"
        [disabled]="disabled"
        (click)="onClick($event)"
        [captureId]="dataCy">
    <div class="addButton-label" [i18nKey]="labelKey"></div>
    <i class="fas fa-plus"></i>
</button>
